import React from 'react'
import CustomModal from 'components/global/CustomModal'
import useFormSubmit from 'helper/Hooks/formSubmit'
import { leagueGamesStore } from 'state/league/leageGames'
import AddGameForm from './ModalContent/AddGameForm'
import CustomModalFooter from 'components/global/CustomModalFooter'

const AddGameModal: React.FC = () => {
  const { form, handleSubmit } = useFormSubmit()
  const { addGameModal, setAddGameModal, setSelectedGame } = leagueGamesStore(
    store => ({
      addGameModal: store.addGameModal,
      setAddGameModal: store.setAddGameModal,
      setSelectedGame: store.setSelectedGame,
    }),
  )

  const closeModal = () => {
    setSelectedGame(null)
    setAddGameModal(false)
  }

  return (
    <CustomModal
      openModal={addGameModal}
      isCloseModalCustom
      closeModal={closeModal}
      title="Add a game"
      footer={
        <CustomModalFooter
          multibutton={false}
          btnAlignment="justify-end"
          btnText="Save game"
          closeModal={closeModal}
          onSubmit={handleSubmit}
        />
      }
    >
      <AddGameForm form={form} />
    </CustomModal>
  )
}

export default AddGameModal
